<template>
    <yxt-input
      v-model="getValue"
      :placeholder="$t('pc_biz_enterName'/* 请输入直播名称 */)"
      maxlength="50"
      show-word-limit
      v-bind="$attrs.attrs"
      v-on="$attrs.on"
    />
</template>
<script>
export default {
  name: 'LiveName',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped lang="less"></style>
